import "mapbox-gl/dist/mapbox-gl.css";
import React from "react";

import { ApolloProvider } from "@apollo/client";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createRoot } from "react-dom/client";
import { RecoilRoot } from "recoil";

import { ApolloClient } from "api";

// Routes
import AppRoutes from "./routes";
import * as serviceWorker from "./serviceWorker";
import theme from "./theme";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container missing in index.html");
}
const root = createRoot(container);

root.render(
  <ApolloProvider client={ApolloClient}>
    <ThemeProvider theme={theme}>
      <RecoilRoot>
        <CssBaseline />
        <AppRoutes />
      </RecoilRoot>
    </ThemeProvider>
  </ApolloProvider>
);

serviceWorker.unregister();
